<app-modal>
	<div modal-header>
		<span  i18n="Modal Titel for Registration@@register.modal.title">Sign Up</span>
	</div>
	<div modal-body>
		<div class="form-group text-center">
			<label i18n="Ask if already registed@@register.modal.label.alreadyRegistered">Already Registered?</label>
			&nbsp; <a [routerLink]="['', {outlets: { modal: ['login']}}]" skipLocationChange i18n="Opens Login Modal@@register.modal.link.login">Log in here</a>
		</div>
		<platform-register-form></platform-register-form>
	</div>
</app-modal>